const storeId = {
  USER: 'USER',
  BASIC: 'BASIC',
  EXPORT: 'EXPORT'
};

export default storeId;
